import { render, staticRenderFns } from "./NavigationFooter.vue?vue&type=template&id=179ce5f9"
import script from "./NavigationFooter.vue?vue&type=script&lang=ts"
export * from "./NavigationFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports